const organizations = ['US', 'CA'];

class ImportValidator {
  validateOrganization = (organization) => {
    return organization !== null
      && organizations.indexOf(organization?.toUpperCase()) > -1
      ? organizations[organizations.indexOf(organization?.toUpperCase())]
      : organizations[0];
  };

  validateTiles = (tiles) => {
    return tiles !== null ? tiles.split(',') : [];
  }
}

export default new ImportValidator();
